import React from "react";
import { Typography, Stack } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import moment from "moment-timezone";

const errorMessageMapper = (err) =>
  ({
    invalidDate: "Invalid date",
    minDate: "Date must be in the future",
    maxDate: "Please select a date in the next 30 days",
  })[err] || err;

const CustomDatePicker = ({
  label,
  required,
  minDays,
  maxDays,
  inputFormat,
  outputFormat,
  onChange,
  value, // dont remove this
  helperText,
  error,
  ...rest
}) => {
  const [dateError, setDateError] = React.useState("");
  const minDate = moment(new Date()).add(minDays, "days");
  const maxDate = moment(new Date()).add(maxDays, "days");

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack spacing={1}>
        <Typography variant="customLable" color="common.inputCustomLable">
          {label}
          {required && <span style={{ color: "#C50F1F" }}>*</span>}
        </Typography>
        <MobileDatePicker
          reduceAnimations
          disableHighlightToday
          {...rest}
          format={inputFormat}
          onError={(error) => setDateError(error)}
          onChange={(value) => {
            let formattedDate = value;
            if (outputFormat) {
              formattedDate = formattedDate?.format(outputFormat);
            }
            onChange(formattedDate);
          }}
          variant="outlined"
          fullWidth
          minDate={minDate}
          maxDate={maxDate}
          slotProps={{
            textField: {
              error: error || !!dateError,
              helperText: helperText || errorMessageMapper(dateError),
              sx: { input: { cursor: "pointer" } },
            },
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
};
export default CustomDatePicker;
